<template>
  <v-card>
    <v-card-title>
      <span class="headline">Add Brokers</span>
    </v-card-title>
    <v-data-table :items="newBrokers"
                  v-model="selectedBroker"
                  :headers="headers"
                  item-key="id"
                  no-data-text="No new brokers available"
                  select-all
                  class="elevation-1">

      <template slot="headerCell"
                slot-scope="props">
        <v-tooltip bottom>
          <span slot="activator">
            {{ props.header.text }}
          </span>
          <span>
            {{ props.header.text }}
          </span>
        </v-tooltip>
      </template>
      <template slot="items"
                slot-scope="props">
        <td>
          <v-checkbox primary
                      hide-details
                      v-model="props.selected">
          </v-checkbox>
        </td>
        <td>{{ props.item.username }}</td>
        <td>{{ props.item.company }}</td>

      </template>
    </v-data-table>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn color="blue darken-1"
             flat
             @click.native="addBrokers()">Ok</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import db from './fireBaseInit'
import brokerName from './BrokerName'
import firebase from 'firebase'
import moment from 'moment'

export default {
  components: { brokerName, toolbar },
  props: ['freightID'],
  name: 'addBrokers',
  data () {
    return {
      newBrokers: [],
      selectedBroker: [],
      brokers: [],
      user: {},
      shipment: {},
      headers: [
        {
          text: 'Brokers',
          align: 'left',
          sortable: true,
          value: false
        },
        { text: 'Company', value: false }
      ]
    }
  },
  firestore () {
    return {
      shipment: db.collection('freight').doc(this.freightID),
      user: db.collection('users').doc(firebase.auth().currentUser.uid)
    }
  },
  mounted: function () {
    this.$bind('brokers', db.collection('users').where('isBroker', '==', true))
      .then((doc) => {
        this.updateBrokers()
      })
      .catch((error) => {
        console.log('error in loading: ', error)
      })
  },
  methods: {
    addBrokers: function () {
      if (this.selectedBroker.length > 0) {
        var brokerList = {}
        for (var i = 0; i < this.selectedBroker.length; i++) {
          brokerList[this.selectedBroker[i].id] = true
        }
        // update new brokers
        var msg = {}
        var quote = {}
        msg['message'] = 'Please Quote this Shipment'
        msg['sender'] = firebase.auth().currentUser.uid
        msg['created'] = moment().unix()

        for (var brokerKey in brokerList) {
          db.collection('conversations').doc(this.freightID).collection('brokers').doc(brokerKey).collection('messages').add(msg)
          quote['quote'] = '$0'
          quote['status'] = 'New'
          quote['selected'] = false
          quote['isActive'] = true
          db.collection('conversations').doc(this.freightID).collection('brokers').doc(brokerKey).set(quote)
        }

        // update broker NewMessage
        var userList = this.shipment.newMessages
        var messages = {}
        for (brokerKey in brokerList) {
          userList[brokerKey] = true
        }
        messages['newMessages'] = userList
        db.collection('freight').doc(this.freightID).update(messages)

        // ok Lets send some texts and push
        var sms = {}
        var push = {}
        for (brokerKey in brokerList) {
          db.collection('users').doc(brokerKey).get().then((snap) => {
            console.log(snap.data().sendSMS)
            if (snap.data().sendSMS) {
              sms['phoneNumber'] = snap.data().mobile
              sms['company'] = this.user.company
              sms['messageType'] = 'Freight Quote'
              console.log(sms)
              db.collection('sms').add(sms)
            }
            if (snap.data().sendPush) {
              push['sendTo'] = snap.id
              db.collection('push').add(push)
            }
          })
        }

        // update broker list
        for (var key in this.shipment.brokers) {
          brokerList[key] = true
        }
        var brokerObj = { brokers: brokerList }
        db.collection('freight').doc(this.freightID).update(brokerObj)
      }
      this.$emit('closeBroker')
    },
    buildMap: function (obj) { // used to get values out of an Object
      let map = new Map()
      Object.keys(obj).forEach(key => {
        map.set(key, obj[key])
      })
      return map
    },
    updateBrokers: function () {
      if (this.brokers.length > 0) {
        this.newBrokers = this.brokers.slice()
        var brokerMap = this.buildMap(this.shipment.brokers)

        for (var i = 0; i < this.newBrokers.length; i++) {
          for (let [key, value] of brokerMap) {
            if (this.newBrokers[i].id === key && value) {
              this.newBrokers.splice(i, 1)
            }
          }
        }
        this.showBrokers = true
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/AddBrokers.vue